import { FC, useEffect, useState } from "react";
import { Button, Checkbox, Col, Modal, Row } from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { UserManagement, Role, Name } from "../../../../types/user-management";

import Permissions from "../data/permissions";

interface Props {
  user: UserManagement | undefined;
  visibleEdit: boolean;
  setVisibleEdit: React.Dispatch<React.SetStateAction<boolean>>;
  setUserEdit: React.Dispatch<React.SetStateAction<UserManagement | undefined>>;
  onUserEdited: (id: number, roles: Role[]) => void;
}

export const PermissionsEditModal: FC<Props> = ({ user, visibleEdit, setVisibleEdit, setUserEdit, onUserEdited }) => {
  const [per, setPer] = useState([...Permissions]);

  const btns = [
    <Button key="cancel" onClick={() => handleCancel()}>
      Cancel
    </Button>,

    <Button
      key="submit"
      type="primary"
      onClick={() => {
        if (user) {
          const roles: Role[] = per.filter((pe) => pe.value).map((pe) => ({ id: pe.id, name: pe.label as Name }));
          onUserEdited(user.id, roles);
          setVisibleEdit(false);
        }
      }}
    >
      Save
    </Button>
  ];

  const handleCancel = () => {
    setVisibleEdit(false);
    setUserEdit(undefined);
    setPer([...Permissions]);
  };

  const onChange = (e: CheckboxChangeEvent, checkB: { value: boolean; label: string }) => {
    checkB.value = e.target.checked;
    setPer([...per]);
  };

  const fixPer = () => {
    const array: Role[] = user?.roles || [];

    for (let i = 0; i < array.length; i++) {
      const check = per.find((ch) => ch.label === array[i].name);
      if (check) check.value = true;
    }
    setPer([...per]);
  };

  useEffect(() => {
    fixPer();
  }, [user]);

  return (
    <>
      <Modal
        visible={visibleEdit}
        title={`${user?.firstName} ${user?.lastName}`}
        centered
        onCancel={() => handleCancel()}
        // onOk={() => form.submit()}
        // okText={isEditing ? "Edit" : "Submit"}
        footer={btns}
      >
        <h4>Permissions:</h4>
        <hr style={{ marginBottom: "20px" }} />

        {per.map((checkB) => (
          <Row key={checkB.label} style={{ marginBottom: "25px" }}>
            <Col>
              <Checkbox
                checked={checkB.value}
                onChange={(event: CheckboxChangeEvent) => {
                  onChange(event, checkB);
                }}
              >
                {checkB.label}
              </Checkbox>
            </Col>
          </Row>
        ))}
      </Modal>
    </>
  );
};
